import { render, staticRenderFns } from "./CustomHeader.vue?vue&type=template&id=a10b3f80"
import script from "./CustomHeader.vue?vue&type=script&lang=js"
export * from "./CustomHeader.vue?vue&type=script&lang=js"
import style0 from "./CustomHeader.vue?vue&type=style&index=0&id=a10b3f80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports